exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* App Colors\n------------------------------------------------------------ */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/node_modules/postcss-loader?{"ident":"postcss"}!E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/styles/firecoding.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles/firecoding.scss
// module chunks = styles